"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Token = /*#__PURE__*/function (_Component) {
  function Token(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Token);
    _this = _callSuper(this, Token, [props]);
    _this.deleteToken = _this.deleteToken.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(Token, _Component);
  return (0, _createClass2["default"])(Token, [{
    key: "deleteToken",
    value: function deleteToken() {
      this.props.deleteToken(this.props.data.text);
    }
  }, {
    key: "render",
    value: function render() {
      var cls = 'token';
      if (this.props.data.highlight) {
        cls += ' token-highlight';
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "token-container",
        onClick: this.deleteToken
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: cls
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "token-text"
      }, this.props.data.text)));
    }
  }]);
}(_react.Component);
Token.propTypes = {
  data: _propTypes["default"].object,
  deleteToken: _propTypes["default"].func.isRequired
};
var InputBox = /*#__PURE__*/function (_Component2) {
  function InputBox(props) {
    var _this2;
    (0, _classCallCheck2["default"])(this, InputBox);
    _this2 = _callSuper(this, InputBox, [props]);
    (0, _defineProperty2["default"])(_this2, "handleBlur", function () {
      _this2.handleString(_this2.state.value);
    });
    (0, _defineProperty2["default"])(_this2, "handleChange", function (event) {
      var v = event.target.value;
      var x = v.indexOf(' ') >= 0 || v.indexOf(',') >= 0;
      if (x === true) {
        _this2.handleString(v);
      } else {
        _this2.setState({
          value: v
        });
        _this2.props.changeInputText(v);
      }
    });
    _this2.state = {
      value: ''
    };
    _this2.keyDown = _this2.keyDown.bind(_this2);
    return _this2;
  }
  (0, _inherits2["default"])(InputBox, _Component2);
  return (0, _createClass2["default"])(InputBox, [{
    key: "handleString",
    value: function handleString(inputString) {
      var emails = inputString.split(/,| /);
      var i;
      for (i = 0; i < emails.length; i++) {
        var isValid = this.validateEmail(emails[i]);
        if (isValid === true) {
          this.addToken(emails[i]);
        }
      }
      this.setState({
        value: ''
      });
      this.props.changeInputText('');
    }
  }, {
    key: "checkTokenRemoval",
    value: function checkTokenRemoval() {
      if (this.state.value.length == 0) {
        this.props.backToken();
      }
    }
  }, {
    key: "validateEmail",
    value: function validateEmail(email) {
      if (email.length > 0) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }
      return false;
    }
  }, {
    key: "addToken",
    value: function addToken(token) {
      this.props.addToken(token);
    }
  }, {
    key: "keyDown",
    value: function keyDown(event) {
      switch (event.keyCode) {
        case 13: // enter
        case 32: // space
        case 188:
          // comma
          event.preventDefault();
          if (this.validateEmail(this.state.value)) {
            this.addToken(this.state.value);
          }
          this.setState({
            value: ''
          });
          break;
        case 8:
          // backspace
          this.checkTokenRemoval();
          break;
        default:
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
        ref: "emailInput",
        type: "text",
        value: this.state.value,
        placeholder: this.props.placeholder,
        onKeyDown: this.keyDown,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        style: {
          padding: 15,
          border: 'none',
          background: 'none'
        },
        className: "width-100%"
      }));
    }
  }]);
}(_react.Component);
var TokenBox = /*#__PURE__*/function (_Component3) {
  function TokenBox(props) {
    var _this3;
    (0, _classCallCheck2["default"])(this, TokenBox);
    _this3 = _callSuper(this, TokenBox, [props]);
    (0, _defineProperty2["default"])(_this3, "onBackKey", function () {
      _this3.changeHighlight(true);
    });
    (0, _defineProperty2["default"])(_this3, "onInputTextChange", function (text) {
      _this3.setState({
        inputText: text
      });
      if (text.length > 0) _this3.changeHighlight(false);
    });
    (0, _defineProperty2["default"])(_this3, "onTokenDelete", function (token) {
      var t = _this3.state.tokens.slice();
      var match = false;
      var i;
      for (i = 0; i < t.length; i++) {
        if (t[i].text == token) {
          match = i + 1;
        }
      }
      if (match) {
        var to = _this3.state.tokens.filter(function (t) {
          return t.text !== token;
        });
        _this3.setState({
          tokens: to
        });
        _this3.props.setEmails(_this3.state.tokens);
      }
    });
    _this3.state = {
      tokens: [],
      inputText: 'placeholder'
    };
    _this3.onInputTextChange = _this3.onInputTextChange.bind(_this3);
    _this3.changeHighlight = _this3.changeHighlight.bind(_this3);
    _this3.onTokenAdded = _this3.onTokenAdded.bind(_this3);
    return _this3;
  }
  (0, _inherits2["default"])(TokenBox, _Component3);
  return (0, _createClass2["default"])(TokenBox, [{
    key: "onTokenAdded",
    value: function onTokenAdded(newToken) {
      newToken = newToken.toLowerCase();
      var t = this.state.tokens;
      var newT = true;
      var i = 0;
      for (i = 0; i < t.length; i += 1) {
        if (t[i].text === newToken) {
          newT = false;
          return false;
        }
      }
      if (newT) {
        t.push({
          text: newToken,
          highlight: false
        });
        this.setState({
          tokens: t
        });
        this.props.setEmails(this.state.tokens);
      }
    }
  }, {
    key: "changeHighlight",
    value: function changeHighlight(h) {
      var ta = this.state.tokens;
      if (ta && ta.length > 0) {
        var lastToken = ta[ta.length - 1];
        if (!h) {
          ta[ta.length - 1].highlight = h;
        } else if (lastToken && lastToken.highlight) {
          // delete
          ta.pop();
        } else {
          ta[ta.length - 1].highlight = h;
        }
        this.setState({
          tokens: ta
        });
      }
    }
  }, {
    key: "clearTokens",
    value: function clearTokens() {
      this.setState({
        tokens: []
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "token-box full-height",
        onClick: this.onClicked
      }, this.state.tokens.map(function (t) {
        return /*#__PURE__*/_react["default"].createElement(Token, {
          deleteToken: _this4.onTokenDelete,
          key: t.text,
          data: t
        });
      }), /*#__PURE__*/_react["default"].createElement(InputBox, {
        ref: function ref(_ref) {
          return _this4.inputBox = _ref;
        },
        changeInputText: this.onInputTextChange,
        addToken: this.onTokenAdded,
        backToken: this.onBackKey,
        placeholder: this.state.tokens.length === 0 ? this.props.placeholder : undefined
      }));
    }
  }]);
}(_react.Component);
TokenBox.propTypes = {
  setEmails: _propTypes["default"].func,
  placeholder: _propTypes["default"].string
};
var _default = exports["default"] = TokenBox;